"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Add possibility to detach lightbox in handheld view
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.content.lightbox = {
    fancyboxDefaultOptions: {
        margin: 0,
        padding: 50,
        openMethod: 'modalIn',
        tpl: {
            wrap: '<div class="fancybox-wrap" id="fancybox" tabIndex="-1"><div class="fancybox-skin modal-dialog"><div class="fancybox-outer modal-content"><div class="fancybox-inner modal-body"></div></div></div></div>',
            error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
            closeBtn: '<button class="fancybox-item fancybox-close btn--close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>'
        },
        helpers: {
            title: {
                type: 'inside',
                position: 'bottom'
            },
            overlay: {
                locked: false
            }
        },
    },
    anchors: {},
    anchorsInline: {},
    setAnchors: function () {
        $('a.lightbox-link').prop({
            'rel': 'contentbox'
        });
        _main_1.txGs1Base.content.lightbox.anchors = $('a[rel=contentbox]');
        _main_1.txGs1Base.content.lightbox.anchorsInline = $('a[rel=contentbox-inline]');
    },
    /**
     *
     */
    detach: function () {
        'use strict';
        _main_1.txGs1Base.content.lightbox.anchors.off('click').on('click.txGs1Base', function (event) {
            event.preventDefault();
            window.location = $(this).attr('href');
        });
    },
    /**
     * Attach regular content boxes (load content from link)
     */
    attach: function () {
        'use strict';
        _main_1.txGs1Base.content.lightbox.anchors.off('click.txGs1Base').fancybox($.extend(true, {}, this.fancyboxDefaultOptions, {
            type: 'ajax',
            ajax: {
                dataType: 'html',
                data: { 'type': '77' } // lightbox_pagetype
            },
            live: true,
            afterShow: function () {
                $.eventEmitter.emit('contentUpdate');
                $('.modal-dialog').animate({
                    top: 0,
                    opacity: 1
                }, 500);
            }
        }));
    },
    /**
     * Attach inline content boxes
     */
    attachInline: function () {
        'use strict';
        _main_1.txGs1Base.content.lightbox.anchorsInline.off('click.txGs1Base').fancybox($.extend(true, {}, this.fancyboxDefaultOptions, {
            type: 'inline',
            live: true,
            afterShow: function () {
                $.eventEmitter.emit('contentUpdate');
                $('.modal-dialog').animate({
                    top: 0,
                    opacity: 1
                }, 500, function () {
                    _main_1.txGs1Base = _main_1.txGs1Base || {};
                    _main_1.txGs1Base.content.lightbox = _main_1.txGs1Base.content.lightbox || {};
                    _main_1.txGs1Base.content.lightbox.isActive = true;
                });
            }
        }));
    }
};
exports.default = {};
